export const SMART_REPLY_BUTTON_TEXT = 'Smart Reply';
